import api from './interceptor';

const BASE_URL_V2 = 'api/v2/database';

export default {
  // API Version 2
  getByClinicId: clinicId => api.get(`${BASE_URL_V2}/${clinicId}`),
  create: params => api.post(`${BASE_URL_V2}`, params),
  updateByDbId: (dbId, params) => api.put(`${BASE_URL_V2}/${dbId}`, params),
  delete: clinicId => api.delete(`${BASE_URL_V2}/${clinicId}`),
};
